import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import moment, { Moment } from 'moment';

// @ts-ignore
import { selectFirstDate } from 'components/DatePagination/selectors';
import { DayOfTheWeekOptionsType } from './types';

const selectDatesOfTheWeek = createDeepEqualSelector(
    selectFirstDate,
    (firstDateState: Moment) => {
        const momentDate = moment(firstDateState, 'YYYY-MM-DD');
        const datesOfTheWeek = [];

        for (let i = 0; i < 7; i += 1) {
            datesOfTheWeek.push(momentDate.format('YYYY-MM-DD'));
            momentDate.add(1, 'day');
        }

        return datesOfTheWeek;
    }
);

const selectOptions = createDeepEqualSelector(
    selectDatesOfTheWeek,
    (datesOfTheWeek): DayOfTheWeekOptionsType =>
        datesOfTheWeek.map(date => ({
            key: date,
            value: date,
            text: moment(date).format('dddd Do MMM')
        }))
);

const makeSelectOptions = (): typeof selectOptions => selectOptions;

export { selectDatesOfTheWeek, makeSelectOptions };
